@import '../../constants/spacing.module.less';

.resultCard {
  position: relative;
  border: 1px solid var(--grey-200);
  border-radius: @space-4;
  padding: @space-16;
  margin-bottom: @space-12;
  cursor: pointer;
  background-color: var(--white);
  transition: all 0.2s ease;

  &:hover {
    border-color: var(--blue-500);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
}

.resultCardSelected {
  border-color: var(--blue-500);
}

.resultCardCheckmark {
  position: absolute;
  top: @space-8;
  right: @space-8;
  color: var(--blue-500);
  font-size: 20px;
  > svg {
    width: 16px;
  }
}

.resultCardHeader {
  gap: @space-8;
  align-items: center;
  margin-bottom: @space-8;
}

.codeBadge {
  padding: @space-4 @space-12;
  border: 2px solid var(--green-500);
  border-radius: @space-4;
  color: var(--grey-900);
}

.confidenceBadge {
  padding: @space-4 @space-8;
  border-radius: @space-4;
  text-transform: uppercase;
}

.confidenceHigh {
  background-color: var(--green-100);
}

.confidenceMedium {
  background-color: var(--gold-200);
}

.confidenceLow {
  background-color: var(--grey-100);
}

.reasoning {
  margin-bottom: @space-8;
  margin-top: @space-12;
  color: var(--grey-700);
  font-style: italic;
  display: block;
}

.chapter {
  color: var(--grey-600);
  display: block;
  margin-top: @space-4;
}

.resultsContainer {
  width: 100%;
  flex-basis: 100%;
  margin-top: @space-12;
  padding: @space-16;
  background-color: var(--grey-200);
  border-radius: @space-4;
}

.resultsHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: @space-12;
}

.suggestionContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
}

.suggestButton {
  display: inline-flex;
  align-items: center;
  gap: @space-8;
  white-space: nowrap;

  svg {
    margin-right: @space-4;
    width: @space-16;
    height: @space-16;
  }
}
